export interface NormalizeResponse {
  status: string;
  study_uid: string;
  total_instances_found: number;
  series_processed: number;
  enhanced_datasets_created: number;
  total_datasets_uploaded: number;
  processed_series: Array<{
    series_uid: string;
    instances_count: number;
    rule_matched?: string;
    status: string;
    error?: string;
  }>;
  message: string;
  errors?: string[];
  error_count?: number;
}

export async function studyNormalize(
  token: string,
  studyInstanceUID: string
): Promise<NormalizeResponse> {
  try {
    const { normalizeStudyURL } = (window as any).data.normalize;
    
    const response = await fetch(normalizeStudyURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        studyInstanceUID: studyInstanceUID,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to trigger normalize: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log('Normalize response:', data);
    return data;
  } catch (error) {
    console.error('Error in studyNormalize:', error);
    throw error;
  }
}

// Download normalized study from the enhanced DICOM store
export async function downloadNormalizedStudy(
  token: string,
  studyInstanceUID: string,
  studyDescription?: string
) {
  try {
    const { downloadStudyURL } = (window as any).data.download;
    const timestamp = new Date().toISOString().split('T')[0];
    const safeDescription = studyDescription?.replace(/\s+/g, '_') || 'study';
    const filename = `${timestamp}_${safeDescription}_normalized.zip`;
    
    console.log('Downloading normalized study with source_store: enhanced');
    
    const response = await fetch(downloadStudyURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        StudyInstanceUID: studyInstanceUID,
        filename: filename,
        source_store: 'enhanced',  // This tells backend to download from enhanced store
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to download: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    // Trigger browser download
    const link = document.createElement('a');
    link.href = data.download_url;
    link.download = data.filename || filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('Download initiated successfully');
    return data;
  } catch (error) {
    console.error('Error downloading normalized study:', error);
    throw error;
  }
}